Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.HeaderView extends Backbone.View
  template: JST["backbone/templates/monitoring/reports/executive/header"]

  events:
    'click .report-index-link' : 'scrollTo'

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template(columns: @_getColumns()))

    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    @$el.find('input').datepicker(
      autoclose: true
      startDate: threeYearsAgo
      endDate: new Date()
      format: 'dd/mm/yyyy'
      todayBtn: 'linked'
      todayHighlight: true
    ).on('changeDate', @updateDates)

    @$el.find('#range-from').datepicker('setDate', @options.fromISO)
    @$el.find('#range-to').datepicker('setDate', @options.toISO)
    @$el.find('#benchmark-from').datepicker('setDate', @options.fromBenchmark)
    @$el.find('#benchmark-to').datepicker('setDate', @options.toBenchmark)

    return this

  _getColumns: ->
    sections = @options.settings.sections
    firstColumn = citrus = sections.slice(0, Math.ceil(sections.length/2))
    secondColumn = sections.slice(Math.ceil(sections.length/2), sections.length)
    [firstColumn, secondColumn]

  updateDates: (evt) =>
    id = $(evt.target).attr('id')
    dateName = {
      'range-from': 'fromISO'
      'range-to': 'toISO'
      'benchmark-from': 'fromBenchmark'
      'benchmark-to': 'toBenchmark'
    }[id]

    if id == 'range-from' || id == 'benchmark-from'
      date = new Date(evt.date.getUTCFullYear(), evt.date.getUTCMonth(), evt.date.getUTCDate(), 0, 0, 0, 0)
    else
      date = new Date(evt.date.getUTCFullYear(), evt.date.getUTCMonth(), evt.date.getUTCDate(), 23, 59, 59, 999)
    @options[dateName] = date


  scrollTo: (event) ->
    parsed_title = $(event.currentTarget).text().trim()
    selector = ".title :contains(\"" + parsed_title + "\")"
    offset_header =  @$el.find('.repo-header.navbar').outerHeight() + ($('#main-header').outerHeight() + 20)
    if $(selector).offset()
      $('html, body').animate { scrollTop: $(selector).offset().top - offset_header }, 0
